// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3YV92","label":"Section_label__2RFIu","contentWrap":"Section_contentWrap__UJyXX","footer":"Section_footer__SLtNi","footerInner":"Section_footerInner__NR71r"};